import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { S1ReadableDatePipe } from '../../pipes/s1-readable-date.pipe';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { TranslatorService } from '@app/core/translator/translator.service';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { itLocale } from 'ngx-bootstrap/locale';

defineLocale('it', itLocale);

@Component({
    selector: 's1-input-datepicker',
    templateUrl: './s1-input-datepicker.component.html',
    styleUrls: ['./s1-input-datepicker.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class S1InputDatepicker {

  @Input() control: UntypedFormControl;
  @Input() label: string = '';
  @Input() readonly: boolean = false;
  @Input() maxDate: Date;
  @Input() minDate: Date;
  @Input() placeholder: string = '';

  bsConfig = {
    containerClass: 'theme-red',
    dateInputFormat: 'DD/MM/YYYY',
    minDate: null,
    maxDate: null
  }
  
  constructor(
    private readableDatePipe: S1ReadableDatePipe,
    private localeService: BsLocaleService,
    private translatorService: TranslatorService
  ) {
    this.localeService.use(this.translatorService.getLanguageInUse());
  }

  checkIsValid(): boolean {

    // controllo se è stato impostato il maxDate
    if (this.maxDate) {
      this.bsConfig.maxDate = this.maxDate
    }

    this.bsConfig.minDate = this.minDate

    return this.control.valid || !this.control.touched;

  }

  readableDate() {
    return this.readableDatePipe.transform(this.control.value)
  }
  
}